export default __webpack_public_path__ + "static/media/landingBackground3Mobile.3462a351.png";